import { render, staticRenderFns } from "./Menu.vue?vue&type=template&id=9bcc0be2&"
import script from "./Menu.vue?vue&type=script&setup=true&lang=js&"
export * from "./Menu.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/masayukitenma/Documents/Develop/Matching/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9bcc0be2')) {
      api.createRecord('9bcc0be2', component.options)
    } else {
      api.reload('9bcc0be2', component.options)
    }
    module.hot.accept("./Menu.vue?vue&type=template&id=9bcc0be2&", function () {
      api.rerender('9bcc0be2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Menu.vue"
export default component.exports